// src/components/Login.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem('authToken')) {
      navigate('/');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);

    try {
      const response = await fetch('https://apiportal.mbsays.com/public/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await response.json();
      setLoading(false);

      if (response.ok && data.token) {
        // 1) Token & user
        sessionStorage.setItem('authToken', data.token);
        sessionStorage.setItem('user', JSON.stringify(data.user));

        // 2) Acil durum kişilerinin GET’i
        const ecRes = await fetch(
          'https://apiportal.mbsays.com/public/api/emergency-contacts',
          { headers: { Authorization: `Bearer ${data.token}` } }
        );
        if (ecRes.ok) {
          const contacts = await ecRes.json();
          // Dilersen tüm array’i saklayabilirsin:
          sessionStorage.setItem('emergencyContacts', JSON.stringify(contacts));
          // Veya ilk kişiyi ayrı ayrı:
          if (contacts[0]) {
            sessionStorage.setItem('acil_name', contacts[0].name);
            sessionStorage.setItem('acil_phone', contacts[0].phone);
            sessionStorage.setItem('acil_relationship', contacts[0].relationship);
          }
        }

        navigate('/');
      } else {
        setError(data.message || 'E-posta veya şifre hatalı');
      }
    } catch (err) {
      setLoading(false);
      setError('Giriş sırasında hata oluştu. Lütfen tekrar deneyin.');
      console.error(err);
    }
  };

  return (
    <div className="login-container">
      <h2>Giriş Yap</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit} className="login-form">
        <label>
          E-posta:
          <input
            type="email"
            placeholder="E-posta giriniz"
            value={email}
            onChange={e => setEmail(e.target.value)}
            disabled={loading}
          />
        </label>
        <label>
          Şifre:
          <input
            type="password"
            placeholder="Şifre giriniz"
            value={password}
            onChange={e => setPassword(e.target.value)}
            disabled={loading}
          />
        </label>
        <button type="submit" className="login-button" disabled={loading}>
          {loading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
        </button>
      </form>
      {loading && <div className="loading-spinner"></div>}
    </div>
  );
};

export default Login;

